import React from 'react';
import Button from '../Button/Button';

import './BookNowBar.css';

const BookNowBar = () => {
  return (
    <div className='book-now-bar-container'>
      <div className='book-now-bar-title-container'>
        <h3>Your Health Journey Starts Here</h3>
      </div>
      <div className='book-now-bar-book-phone-container'>
        <Button size='xsmall' href='https://proevolutionwellness.janeapp.com/'>
          Book Now
        </Button>
        <div className='book-now-bar-phone-container'>
          <p className='book-now-bar-phone'>905-303-0337</p>
        </div>
      </div>
    </div>
  );
};

export default BookNowBar;
